import {Types} from "@Common/types";

type Branch = Types.Apis.Payloads.Next.Branch.GetAll.Response[number];

export const mapSearchAsBranchFilter = (search:string) => {
    const searchLowercase = search.toLowerCase();
    return (branch:Branch) => [
        "idBranch",
        "branchName",
        "branchLinkId",
        "branchAddress1",
        "branchAddress2",
        "branchCity",
        "branchState",
    ].some(field => branch[field]?.toLowerCase().includes(searchLowercase))
};
